import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import './style.less';

interface NavHoverMenuProps {
  isOpen: boolean;
  bottom?: number;
}

export const NavHoverMenu: React.FC<NavHoverMenuProps> = ({
  isOpen: propsIsOpen,
  bottom,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(propsIsOpen);

  useEffect(() => {
    const timeout = setTimeout(() => setIsOpen(propsIsOpen), 200);
    return () => clearTimeout(timeout);
  }, [propsIsOpen]);

  return (
    <div
      className={clsx('NavHoverMenu', isOpen && 'NavHoverMenu--open')}
      style={{ bottom }}
    >
      {children}
    </div>
  );
};
